import {
  GetAllQueryTrackerImportsQuery,
  QtImportStatus,
  useImportAbapQueriesMutation
} from 'generated/graphql';
import { MutableRefObject, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type UseProjectsForImportProps = {
  toastRef: MutableRefObject<any>;
  refetchData: () => void;
  data: GetAllQueryTrackerImportsQuery | undefined;
};

export const useProjectsForImport = (props: UseProjectsForImportProps) => {
  const { toastRef, refetchData, data } = props;
  const { t } = useTranslation();

  const [toastMessage, setToastMessage] = useState<string>('');
  const [toastDuration, setToastDuration] = useState<number>();

  const [, importAbapQueries] = useImportAbapQueriesMutation();

  const showToastMessage = (message: string) => {
    setToastMessage(message);

    if (toastRef.current) {
      toastRef.current.show();
    }
  };

  const handleProjectImport = async (projects: string[], startDate: string, endDate: string) => {
    // Retrieves updated list of QT imports before checking for ongoing importing processes
    refetchData();
    const filteredProjects = data?.qtImports
      .filter((project) => project.status === QtImportStatus.PROCESSING)
      .map((project) => project.fileName);
    const projectsSet = new Set(filteredProjects);
    const ongoingProcessingSelectedProjects = projects?.filter((project) =>
      projectsSet.has(project)
    );

    if (!ongoingProcessingSelectedProjects.length) {
      const result = await importAbapQueries({
        projects,
        startDate,
        endDate
      });

      if (result.error) {
        showToastMessage(t('import-abap-queries-dialog-error-message-generic'));
      } else {
        showToastMessage(t('import-abap-queries-dialog-success-message'));
        refetchData();
      }
      setToastDuration(3000);
    } else {
      showToastMessage(
        t('import-abap-queries-dialog-error-message-ongoing-processing', {
          projects: ongoingProcessingSelectedProjects
        })
      );
      setToastDuration(5000);
    }

    toastRef.current.show();
  };

  return {
    handleProjectImport,
    toastMessage,
    toastDuration
  };
};
